/**
 * Enumeration of the possible priority states for a task or goal
 */ export var PriorityName = /*#__PURE__*/ function(PriorityName) {
    /** Urgent state (0-1) */ PriorityName["Urgent"] = "Urgent";
    /** Important state (2-4) */ PriorityName["Important"] = "Important";
    /** Default medium state (5-7) */ PriorityName["Medium"] = "Medium";
    /** Low state (8-10) */ PriorityName["Low"] = "Low";
    return PriorityName;
}({});
/**
 * Access contexts for tasks
 */ export var TaskAccessContext = /*#__PURE__*/ function(TaskAccessContext) {
    /* Plan based tasks access */ TaskAccessContext[TaskAccessContext["Plan"] = 0] = "Plan";
    /** Assignee based tasks access */ TaskAccessContext[TaskAccessContext["AssignedToUser"] = 1] = "AssignedToUser";
    /** My day based tasks access */ TaskAccessContext[TaskAccessContext["MyDay"] = 2] = "MyDay";
    return TaskAccessContext;
}({});
/** Update Plan state */ export var PlanMoveOperationStatus = /*#__PURE__*/ function(PlanMoveOperationStatus) {
    /** Move Plan is in progress. */ PlanMoveOperationStatus["InProgress"] = "InProgress";
    /** Move Plan is completed. */ PlanMoveOperationStatus["Completed"] = "Completed";
    /** Move Plan has completed with errors. */ PlanMoveOperationStatus["CompletedWithErrors"] = "CompletedWithErrors";
    return PlanMoveOperationStatus;
}({});
/**
 * All the possible values for a sensitivity label to enforce group privacy
 */ export var SensitivityLabelGroupPrivacy = /*#__PURE__*/ function(SensitivityLabelGroupPrivacy) {
    SensitivityLabelGroupPrivacy["Public"] = "public";
    SensitivityLabelGroupPrivacy["Private"] = "private";
    SensitivityLabelGroupPrivacy["Unspecified"] = "unspecified";
    return SensitivityLabelGroupPrivacy;
}({});
/**
 * Enum representing the available tabs in the task editor
 */ export var TaskEditorTab = /*#__PURE__*/ function(TaskEditorTab) {
    TaskEditorTab["TaskDetails"] = "taskDetails";
    TaskEditorTab["Planning"] = "planning";
    TaskEditorTab["Attachments"] = "attachments";
    TaskEditorTab["Comments"] = "comments";
    TaskEditorTab["CustomFields"] = "customFields";
    TaskEditorTab["Agent"] = "agent";
    return TaskEditorTab;
}({});
/**
 * Identifies a highlightable field row in the task editor. Set as transient view state when a user
 * clicks a task history card so the matching editor row can render a highlight (and the editor can
 * switch to the row's tab if it lives on another one). Values are stable ids compared by the rows.
 */ export var TaskEditorHighlightField = /*#__PURE__*/ function(TaskEditorHighlightField) {
    TaskEditorHighlightField["Title"] = "title";
    TaskEditorHighlightField["Notes"] = "notes";
    TaskEditorHighlightField["Status"] = "status";
    TaskEditorHighlightField["PercentComplete"] = "percentComplete";
    TaskEditorHighlightField["Priority"] = "priority";
    TaskEditorHighlightField["StartDate"] = "startDate";
    TaskEditorHighlightField["DueDate"] = "dueDate";
    TaskEditorHighlightField["FinishDate"] = "finishDate";
    TaskEditorHighlightField["Recurrence"] = "recurrence";
    TaskEditorHighlightField["Bucket"] = "bucket";
    TaskEditorHighlightField["Assignments"] = "assignments";
    TaskEditorHighlightField["Labels"] = "labels";
    TaskEditorHighlightField["Goals"] = "goals";
    TaskEditorHighlightField["Checklist"] = "checklist";
    TaskEditorHighlightField["Attachments"] = "attachments";
    return TaskEditorHighlightField;
}({});
